import React from 'react';

export default class Page extends React.Component {

	// constructor(...args){
	// 	super(...args);
	// }

	// componentDidMount(){

	// }

	get app(){
		return window.app;
	}
}





// WEBPACK FOOTER //
// ./src/components/Page.js